import SystemSelect from '../order_panel/SystemSelect.jsx';
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import { API_ENDPOINT_OPEN_ORDER } from "../../../data/Endpoints-API.js";
import APIMiddleware from "../../../data/api/Api-Middleware.js";
import { useAccountManagerContext } from "../../../contexts/Account-Manager-Context.js";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import { useMetricsContext } from "../../../contexts/Metrics-Context.js";
import { useChartContext } from "../../../contexts/Chart-Context.js";
import { Order } from "../../../interfaces/Order.js";
import { formatPositionToPipSize, formatPrice, formatPriceUptoDecimals } from "../../../utils/format.js";
import { useOrderContext } from "../../../contexts/Order-Context.js";
import SLTP from "../market_order/OrderSLTP.jsx";
import CreatableSelect from 'react-select/creatable';
import Select from "../../utils/Select.jsx";

import { Ripple } from 'react-ripple-click';
import 'react-ripple-click/dist/index.css';
import UTCTimeConverter from "../order_panel/UTCTimeConverter.jsx";
import {
  getTradingDisabledBannerMessage,
  isTradingDisabled,
} from "../../../utils/tradingLockMessage.ts";
import { useTranslation } from "react-i18next";
import { localizeTradingBannerMessage } from "../../../i18n/tradingLock.js";

//Declaring props
interface ChildProps {
  selectedOrderTab: any;
}
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '15px !important',
    width: '150px',
    borderColor: 'var(--surface-border, #3a4156) !important', // inputBorderColor
    backgroundColor: 'transparent !important',
    boxShadow: state.isFocused ? 'var(--surface-border, #3a4156) !important' : provided.boxShadow, // inputBorderColor
    '&:hover': {
      borderColor: state.isFocused ? '#484848 !important' : provided.borderColor,
      cursor: 'pointer',
    },
    cursor: 'pointer',
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '10px !important',
    color: 'var(--content-primary, #e8eaf0)', // boldTextColor
    borderColor: 'var(--surface-border, #3a4156) !important', // inputBorderColor
    backgroundColor: state.isFocused ? 'rgb(0, 217, 126) !important;' : null, // greenButton
    '&:hover': {
      backgroundColor: 'rgb(0, 217, 126) !important', // greenButton
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'var(--surface-raised, #2f3549) !important', // firstBoxButton
    zIndex: 111,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '120px',
    overflowY: 'auto',
  }),
  input: (provided) => ({
    ...provided,
    padding: '0 !important'
  }),
};
const orderCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '15px !important',
    width: '75px',
    borderColor: 'var(--surface-border, #3a4156) !important', // inputBorderColor
    backgroundColor: 'transparent !important',
    boxShadow: state.isFocused ? 'var(--surface-border, #3a4156) !important' : provided.boxShadow, // inputBorderColor
    '&:hover': {
      borderColor: state.isFocused ? '#484848 !important' : provided.borderColor,
      cursor: 'pointer',
    },
    cursor: 'pointer',
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '10px !important',
    color: 'var(--content-primary, #e8eaf0)', // boldTextColor
    borderColor: 'var(--surface-border, #3a4156) !important', // inputBorderColor
    backgroundColor: state.isFocused ? 'rgb(0, 217, 126) !important;' : null, // greenButton
    '&:hover': {
      backgroundColor: 'rgb(0, 217, 126) !important', // greenButton
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'var(--surface-raised, #2f3549) !important', // firstBoxButton
    zIndex: 111,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '120px',
    overflowY: 'auto',
  }),
  input: (provided) => ({
    ...provided,
    padding: '0 !important'
  }),
};

const PendingOrder: React.FC<ChildProps> = ({ selectedOrderTab }) => {
  const { t } = useTranslation();
  //CONTEXT
  const {
    loadingSymbolContext,

    bidPrice,
    askPrice,
      askPriceExchangeRate,
    bidPriceExchangeRate,
    symbolInfo,
    marketHours,
    symbolData,
    allSymbolOptions,
    selectedSymbolOption,
    handleSymbolOptionChange,
    leverage,
    selectedSymbolExchangeRate,
    lotSteps,
    lotSize,
    unitOptions,
    setCurrentExposureLevel
  } = useSymbolContext();
  const { openOrder, setActiveTab } = useAccountManagerContext();
  const { user, sendDataToServer, selectedAuthSymbol, platFromData, isFirstLoginDisabled, leverageData, fetchUserLeverage } = useAuthContext();
  const { metrics } = useMetricsContext();
  const { selectedStyle } = useChartContext();
  const [buyActive, setBuyActive] = useState(true);
  const [sellActive, setSellActive] = useState(false);
  const [direction, setDirection] = useState("");
  const [orderQuantity, setOrderQuantity] = useState<number | null>("");
  const [stopLoss, setStopLoss] = useState(0.0);
  const [slPips, setSlPips] = useState(0.0);
  const [tpPips, setTpPips] = useState(0.0);
  const [takeProfit, setTakeProfit] = useState(0.0);
  const [orderEntryPrice, setOrderEntryPrice] = useState(0.0);
  const [orderEntryPriceInput, setOrderEntryPriceInput] = useState('');
  const MAX_PRICE_DECIMALS = 10;
  const priceInputPattern = /^\d*\.?\d{0,10}$/;
  const [expiresAt, setExpiresAt] = useState("");
  // const [quantity, setQuantity] = useState();

  const [pointerEvents, setPointerEvents] = useState("all");

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [preDefineQuantities, setPreDefineQuantities] = useState("false");
  const [orderComment, setOrderComment] = useState("");
  const [assetState, setAssetState] = useState({
    type: "base_asset",
    name: symbolInfo.base_asset,
  });
  const [amount, setAmount] = useState<number | null>("");
  const [expiresAtStatus, setExpiresAtStatus] = useState(false);
  const [isOrderOpening, setIsOrderOpening] = useState(false);
  const [selectedLotStep, setSelectedLotStep] = useState(0.0);
  const [selectedLotStepOption, setSelectedLotStepOption] = useState({ value: 0.0, label: '0.0 Lots' });
  const [inputValue, setInputValue] = useState('');

  const [inputQtyValue, setInputQtyValue] = useState('');
  const [selectedQtyOption, setSelectedQtyOption] = useState({ value: 0.0, label: '0.0' });
  const formatCreateLabelLots = (inputValue) => `${inputValue} Lots`;
  const formatCreateLabelQty = (inputValue) => `${inputValue}`;
  const [assetOptions, setAssetOptions] = useState('false');
  const [focusOut, setFocusOut] = useState(true);

  useEffect(() => {
    // Clear size input on symbol change (same for Forex and other markets — default unit is base)
    setOrderQuantity("");
    setAmount("");
    setSelectedQtyOption({ value: 0.1, label: '0.1' });
  }, [selectedAuthSymbol, localStorage.getItem('category')]);

  const handleProfitChange = (data) => {
    setTakeProfit(data)
  };
  const handleLossChange = (data) => {
    setStopLoss(data)
  };
  const handleTPPipsChange = (data) => {
    setTpPips(data)
  };
  const handleSLPipsChange = (data) => {
    setSlPips(data)
  };
  useEffect(() => {
    // Same as other markets: default Size unit to base asset (e.g. EUR for EURUSD, CRV for CRVUSDT)
    setAssetState({
      type: "base_asset",
      name: symbolInfo.base_asset
    });
    if (symbolInfo.trade_type === 'units') {
      // const unitFirst = unitOptions?.length > 0 ? unitOptions[0] : { value: 0.1, label: '0.1' };
      const unitFirst = unitOptions?.length > 0 ? unitOptions[0] : { value: 1000, label: '1k' };
      setSelectedQtyOption(unitFirst);
    } else {
      // const lotFirst = lotSteps?.length > 0 ? lotSteps[0] : { value: 0.1, label: '0.1' };
      const lotFirst = lotSteps?.length > 0 ? lotSteps[0] : { value: 1000, label: '1k' };
      setSelectedLotStep(parseFloat(lotFirst.value));
      setSelectedLotStepOption(lotFirst);
    }
  }, [lotSteps, symbolInfo, unitOptions]);
 

  //  useEffect(() => {
  //   setQuantity(0.00);
  // }, [symbolInfo]);

  // console.log("symbolInfo.base_asset:", symbolInfo.base_asset);
  // console.log("symbolInfo.quote_asset:", symbolInfo.quote_asset);



  // useEffect(() => {
  // }, [
  //   bidPrice,
  //   askPrice,
  //   orderEntryPrice,
  // ]);



  useEffect(() => {
    if (selectedOrderTab === "pending-order" && bidPrice > 0 && askPrice) {
      const price = direction == "Buy" ? parseFloat(askPrice) : parseFloat(bidPrice);
      setOrderEntryPrice(price);
      setOrderEntryPriceInput(formatPriceUptoDecimals(price, MAX_PRICE_DECIMALS));
    }
  }, [selectedOrderTab, direction, selectedAuthSymbol]);

  useEffect(() => {
    setTakeProfit(0.0);
    setStopLoss(0.0);
    setSelectedLotStep(0.0);
  }, [selectedAuthSymbol]);


  const handleDateTimeChange = (event) => {
    setExpiresAt(event);
  };
  const handleDisabledButton = (data) => {
    setIsButtonDisabled(data)
  };
  useEffect(() => {
    //If amount entry price and quantity is not null or nan then it will pass to the condition
    if (!isNaN(amount) && !isNaN(orderEntryPrice) && !isNaN(orderQuantity)) {
      //If the selected type is base asset (BTC)
      //then it will set amount according to given quantity
      if (assetState.type === "base_asset") {
        if (orderQuantity > 0 && orderEntryPrice > 0) {
        setAmount(orderEntryPrice * orderQuantity);
        }
      }
      //If the selected type is quote asset (USDT)
      //then it will set quantity according to given amount
      else if (assetState.type === "quote_asset") {
        if (amount > 0 && orderEntryPrice > 0) {
          setOrderQuantity(amount / orderEntryPrice);
        }
      }
    }
  }, [amount, orderQuantity, orderEntryPrice]);


  const handleAssetChange = (e) => {
    // const { value } = selectedOption;
    setAmount("");
    setOrderQuantity('');
    setInputQtyValue('');

    // setSelectedQtyOption({ value: 1000, label: '1k' });

    // Create a new object with updated values based on selection
    // const updatedAssetState = {
    //   type: value === symbolInfo.base_asset ? "base_asset" : "quote_asset",
    //   name: value,
    // };

    // // Update the state using the updated object
    // setAssetState(updatedAssetState);

    const updatedAssetState = {
      type: e === symbolInfo.base_asset ? "base_asset" : "quote_asset",
      name: e,
    };
    // Update the state using the updated object
    setAssetState(updatedAssetState);
  };
  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '3px !important',
      width: '75px',
      borderColor: 'var(--surface-border, #3a4156) !important', // inputBorderColor
      backgroundColor: '#00000000!important',
      marginLeft: '10px !important', // Add margin on the left
      boxShadow: state.isFocused
        ? '0 0 50px #484848 !important'
        : provided.boxShadow,
      cursor: 'pointer',
      '&:hover': {
        borderColor: 'rgb(0, 217, 126) !important', // greenButton
        cursor: 'pointer',
        boxShadow: '0 0 0 transparent !important',
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      paddingLeft: '10px !important',
      borderColor: state.isFocused
        ? 'rgb(0, 217, 126) !important' // greenButton
        : 'var(--surface-border, #3a4156) !important', // inputBorderColor
      color: 'var(--content-secondary, #b8bcc8) !important', // normalTextColor
    }),
    option: (provided, state, inSettings = true) => ({
      ...provided,
      padding: inSettings ? '0.3rem !important' : '0 !important',
      cursor: 'pointer',
      color: state.isSelected
        ? 'rgb(0, 217, 126) !important' // greenButton
        : 'var(--content-secondary, #b8bcc8) !important', // normalTextColor
      borderBottom: '1px solid var(--surface-bg, #1a1f36)', // bodyColor
      backgroundColor: state.isSelected ? 'var(--surface-bg, #1a1f36) !important' : 'transparent', // bodyColor
      '&:hover': {
        backgroundColor: 'rgb(0, 217, 126) !important', // greenButton
        color: '#1a1f36 !important', // bodyColor
      },
      '&:nth-last-child(1)': {
        borderBottom: 'none !important',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--surface-raised, #2f3549) !important', // firstBoxButton
      margin: '0.3rem 0.8rem 0 1rem !important', // Add margin on the left
      zIndex: 111,
      left: '-10px', // Adjust position if needed
      width: '80px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '100px', // Reduced height
      minHeight: '3px',
      width: '80px', // Ensures the menu list width matches the menu container
      overflowY: 'auto',
    }),
  };


  const expiryDate = (e) => {
    if (e.target.checked == true) {
      e.target.parentNode.children[0].setAttribute("aria-checked", true);
      setExpiresAtStatus(e.target.checked);
    } else {
      e.target.parentNode.children[0].setAttribute("aria-checked", false);
      setExpiresAt("");
      setExpiresAtStatus(e.target.checked);
    }
  };
  // leverageData is now a single object (not array) for the selected symbol only
  const getCurrentSymbolLeverage = () => {
    if (!leverageData || !selectedAuthSymbol || leverageData.symbol_name !== selectedAuthSymbol) {
      return null;
    }
    return leverageData;
  };

  // Fetch leverage when symbol changes (removed fetchUserLeverage from deps to prevent infinite loop)
  useEffect(() => {
    if (user?.userId && selectedAuthSymbol) {
      fetchUserLeverage(user.userId, selectedAuthSymbol);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAuthSymbol, user?.userId]);

  const getMinimumLeverage = (userLeverage, groupLeverage, symbolLeverage) => {

    const parsedUserLeverage = parseFloat(userLeverage);
    const parsedGroupLeverage = parseFloat(groupLeverage);
    const parsedSymbolLeverage = parseFloat(symbolLeverage);
    // If groupLeverage is defined and not NaN
    if (groupLeverage !== undefined && groupLeverage !== null && groupLeverage !== 'null' && !isNaN(parsedGroupLeverage)) {
      return Math.min(parsedUserLeverage, parsedGroupLeverage);
    }

    // If symbolLeverage is defined and not NaN
    if (symbolLeverage !== undefined && symbolLeverage !== null && symbolLeverage !== 'null' && !isNaN(parsedSymbolLeverage)) {
      return Math.min(parsedUserLeverage, parsedSymbolLeverage);
    }

    // Default to userLeverage or 1 if userLeverage is NaN
    return isNaN(parsedUserLeverage) ? 1 : parsedUserLeverage;
  };

  const countLetters = (e) => {
    const counter = e.target.value.split("").length;
    const countBox = document.getElementById("count-comment-letters-po");
    if (counter <= 100 && countBox != null) {
      countBox.innerText = counter;
    } else {
      e.target.value = e.target.value.slice(0, 100);
    }
  };

  const handleBuySellOrderClick = (buy: boolean) => {
    setBuyActive(buy);
    setSellActive(!buy);
    setDirection(buy ? "Buy" : "Sell");
  };

  const handleSLTPDirectionChange = (direction) => {
    setDirection(direction);
    setBuyActive(direction == "Buy" ? true : false);
    setSellActive(direction != "Buy" ? true : false);
    // localStorage.setItem('directions', direction == "Buy" ? 'buy' : 'sell');
  }

  const placeOrder = (dir) => {
    if (user && user.userId != undefined && user.userId > 0) {
      setIsOrderOpening(true);
      setActiveTab("open-orders-acc");
      placePendingOrder(dir);
    }
  };

  const placePendingOrder = (dir) => {
    if (orderEntryPrice > 0) {
      if (dir && orderQuantity > 0 && orderEntryPrice > 0) {
        // Calculate required margin based on trading logic
        // const requiredMargin = calculateOrderRequiredMargin();
        const requiredMargin = dir == "Buy" ? calculateRequiredMarginAccToAskPrice() : calculateRequiredMarginAccToBidPrice();

        // Check if the user has enough balance
        if (requiredMargin < 10) {
          // Show an alert for insufficient balance
          toast.error(`Margin Should be greater than 10 ${metrics?.userCurrencyName || 'EUR'}.`, {
            position: "top-right",
          });
          document.getElementById("closeSound").play();
          setIsOrderOpening(false);
        } else if (metrics.equity >= requiredMargin) {
          // Continue with opening the position
          openPendingOrder_api(requiredMargin, dir);
        } else {
          // Show an alert for insufficient balance
          toast.error(t('toasts.insufficientEquity'), {
            position: "top-right",
          });
          document.getElementById("closeSound").play();
          setIsOrderOpening(false);
        }
      } else {
        toast.error(t('toasts.orderQuantityRequired'), {
          position: "top-right",
        });
        setIsOrderOpening(false);
      }
    } else {
      toast.error(t('toasts.entryPriceRequired'), {
        position: "top-right",
      });
      setIsOrderOpening(false);
    }
  };

  // const calculateOrderRequiredMargin = () => {
  //   let reqMarginWithoutLeverage = orderQuantity * orderEntryPrice * selectedSymbolExchangeRate;

  //   if (
  //     platFromData[6] &&
  //     platFromData[6].availableLeverage &&
  //     Array.isArray(platFromData[6].availableLeverage) &&
  //     platFromData[6].availableLeverage.length > 0 &&
  //     platFromData[6].availableLeverage[0]?.available_leverage &&
  //     Array.isArray(platFromData[6].availableLeverage[0].available_leverage) &&
  //     platFromData[6].availableLeverage[0].available_leverage.length > 0 &&
  //     Array.isArray(platFromData[6].availableLeverage[0].available_leverage[0]?.group_level_leverage) &&
  //     platFromData[6].availableLeverage[0].available_leverage[0].group_level_leverage.length > 0
  //   ) {

  //     let symbolLeverage = platFromData[6]?.availableLeverage[0]?.available_leverage[0].group_level_leverage.sort((a, b) => {
  //       const aLevel = a && a.exposure_level !== null && a.exposure_level !== undefined
  //         ? parseFloat(a.exposure_level)
  //         : Infinity;
  //       const bLevel = b && b.exposure_level !== null && b.exposure_level !== undefined
  //         ? parseFloat(b.exposure_level)
  //         : Infinity;
  //       return aLevel - bLevel;
  //     });

  //     let groupMinLeverage = symbolLeverage.filter(lev => {
  //       // Ensure `lev.exposure_level` exists and is a valid number before comparison
  //       const exposureLevel = lev && lev.exposure_level !== null && lev.exposure_level !== undefined
  //         ? parseFloat(lev.exposure_level)
  //         : NaN;
  //       return !isNaN(exposureLevel) && exposureLevel >= reqMarginWithoutLeverage;
  //     })




  //     let groupDefaultLeverage

  //     if (platFromData[6]?.availableLeverage[0]?.available_leverage[0].group_level_leverage.length > 0 && groupMinLeverage.length == 0) {
  //       groupDefaultLeverage = symbolLeverage[symbolLeverage.length - 1]
  //     } else {
  //       groupDefaultLeverage = groupMinLeverage[0];
  //     }

  //     let minimumLeverage = 1;
  //     if (platFromData[6]?.availableLeverage[0]?.available_leverage[0]) {
  //       minimumLeverage = getMinimumLeverage(
  //         platFromData[6]?.availableLeverage[0]?.available_leverage[0].user_default_leverage,
  //         groupDefaultLeverage.max_leverage,
  //         []
  //       );
  //     }
  //     const lvg = minimumLeverage || 1;
  //     const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate
  //     const requiredMargin = orderQuantity * (converted_entry_price / lvg);
  //     return isNaN(requiredMargin)
  //       ? 0
  //       : requiredMargin < 1 ? requiredMargin.toFixed(5)
  //         : Math.round(requiredMargin * 10) / 10
  //   } else if (
  //     platFromData[6] &&
  //     platFromData[6].availableLeverage &&
  //     Array.isArray(platFromData[6].availableLeverage) &&
  //     platFromData[6].availableLeverage.length > 0 &&
  //     platFromData[6].availableLeverage[0]?.available_leverage &&
  //     Array.isArray(platFromData[6].availableLeverage[0].available_leverage) &&
  //     platFromData[6].availableLeverage[0].available_leverage.length > 0 &&
  //     Array.isArray(platFromData[6].availableLeverage[0].available_leverage[0]?.symbol_default_leverage) &&
  //     platFromData[6].availableLeverage[0].available_leverage[0].symbol_default_leverage.length > 0
  //   ) {
  //     let symbolLeverage = platFromData[6]?.availableLeverage[0]?.available_leverage[0].symbol_default_leverage.sort((a, b) => {
  //       // Handle missing or invalid `exposure_level` values using parseFloat
  //       const aLevel = a && a.exposure_level !== null && a.exposure_level !== undefined
  //         ? parseFloat(a.exposure_level)
  //         : Infinity;
  //       const bLevel = b && b.exposure_level !== null && b.exposure_level !== undefined
  //         ? parseFloat(b.exposure_level)
  //         : Infinity;
  //       return aLevel - bLevel;
  //     })

  //     let symbolMinLeverage = symbolLeverage.filter(lev => {
  //       // Ensure `lev.exposure_level` exists and is a valid number before comparison
  //       const exposureLevel = lev && lev.exposure_level !== null && lev.exposure_level !== undefined
  //         ? parseFloat(lev.exposure_level)
  //         : NaN;
  //       return !isNaN(exposureLevel) && exposureLevel >= reqMarginWithoutLeverage;
  //     })

  //     let symbolDefaultLeverage

  //     if (platFromData[6]?.availableLeverage[0]?.available_leverage[0].symbol_default_leverage.length > 0 && symbolMinLeverage.length == 0) {
  //       symbolDefaultLeverage = symbolLeverage[symbolLeverage.length - 1]
  //     } else {
  //       symbolDefaultLeverage = symbolMinLeverage[0];
  //     }

  //     let minimumLeverage = 1;
  //     if (platFromData[6]?.availableLeverage[0]?.available_leverage[0]) {
  //       minimumLeverage = getMinimumLeverage(
  //         platFromData[6]?.availableLeverage[0]?.available_leverage[0].user_default_leverage,
  //         [],
  //         symbolDefaultLeverage.max_leverage,

  //       );
  //     }
  //     const lvg = minimumLeverage || 1;
  //     const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate
  //     const requiredMargin = orderQuantity * (converted_entry_price / lvg);
  //     return isNaN(requiredMargin)
  //       ? 0
  //       : requiredMargin < 1 ? requiredMargin.toFixed(5)
  //         : Math.round(requiredMargin * 10) / 10
  //   } else if (platFromData[6] &&
  //     platFromData[6].availableLeverage &&
  //     Array.isArray(platFromData[6].availableLeverage) &&
  //     platFromData[6].availableLeverage.length > 0 &&
  //     platFromData[6].availableLeverage[0]?.available_leverage &&
  //     Array.isArray(platFromData[6].availableLeverage[0].available_leverage) &&
  //     platFromData[6].availableLeverage[0].available_leverage.length > 0 &&
  //     platFromData[6]?.availableLeverage[0]?.available_leverage[0].user_default_leverage) {

  //     const lvg = platFromData[6]?.availableLeverage[0]?.available_leverage[0].user_default_leverage || 1;
  //     console.log("minimumLeverage", lvg)
  //     const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate
  //     const requiredMargin = orderQuantity * (converted_entry_price / lvg);
  //     return isNaN(requiredMargin)
  //       ? 0
  //       : requiredMargin < 1 ? requiredMargin.toFixed(5)
  //         : Math.round(requiredMargin * 10) / 10

  //   }
  // };
  const calculateRequiredMarginAccToAskPrice = () => {
    let reqMarginWithoutLeverage = orderQuantity * orderEntryPrice * selectedSymbolExchangeRate *askPriceExchangeRate;

    // Update current exposure level for leverage tier indicator (only when pending order tab is active)
    if (selectedOrderTab === 'pending-order') {
      setCurrentExposureLevel(reqMarginWithoutLeverage);
    }

    const currentLeverage = getCurrentSymbolLeverage();
    if (
      currentLeverage &&
      Array.isArray(currentLeverage.group_level_leverage) &&
      currentLeverage.group_level_leverage.length > 0
    ) {

      let symbolLeverage = currentLeverage.group_level_leverage.sort((a, b) => {
        const aLevel = a && a.exposure_level !== null && a.exposure_level !== undefined
          ? parseFloat(a.exposure_level)
          : Infinity;
        const bLevel = b && b.exposure_level !== null && b.exposure_level !== undefined
          ? parseFloat(b.exposure_level)
          : Infinity;
        return aLevel - bLevel;
      });

      let groupMinLeverage = symbolLeverage.filter(lev => {
        // Ensure `lev.exposure_level` exists and is a valid number before comparison
        const exposureLevel = lev && lev.exposure_level !== null && lev.exposure_level !== undefined
          ? parseFloat(lev.exposure_level)
          : NaN;
        return !isNaN(exposureLevel) && exposureLevel >= reqMarginWithoutLeverage;
      })




      let groupDefaultLeverage

      if (currentLeverage.group_level_leverage.length > 0 && groupMinLeverage.length == 0) {
        groupDefaultLeverage = symbolLeverage[symbolLeverage.length - 1]
      } else {
        groupDefaultLeverage = groupMinLeverage[0];
      }

      let minimumLeverage = 1;
      if (currentLeverage) {
        minimumLeverage = getMinimumLeverage(
          currentLeverage.user_default_leverage,
          groupDefaultLeverage.max_leverage,
          []
        );
      }
      const lvg = minimumLeverage || 1;
      const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate *askPriceExchangeRate;
      const requiredMargin = orderQuantity * (converted_entry_price / lvg);
      return isNaN(requiredMargin)
        ? 0
        : requiredMargin < 1 ? requiredMargin?.toFixed(5)
          : Math.round(requiredMargin * 10) / 10
    } else if (
      currentLeverage &&
      Array.isArray(currentLeverage.symbol_default_leverage) &&
      currentLeverage.symbol_default_leverage.length > 0
    ) {
      let symbolLeverage = currentLeverage.symbol_default_leverage.sort((a, b) => {
        // Handle missing or invalid `exposure_level` values using parseFloat
        const aLevel = a && a.exposure_level !== null && a.exposure_level !== undefined
          ? parseFloat(a.exposure_level)
          : Infinity;
        const bLevel = b && b.exposure_level !== null && b.exposure_level !== undefined
          ? parseFloat(b.exposure_level)
          : Infinity;
        return aLevel - bLevel;
      })

      let symbolMinLeverage = symbolLeverage.filter(lev => {
        // Ensure `lev.exposure_level` exists and is a valid number before comparison
        const exposureLevel = lev && lev.exposure_level !== null && lev.exposure_level !== undefined
          ? parseFloat(lev.exposure_level)
          : NaN;
        return !isNaN(exposureLevel) && exposureLevel >= reqMarginWithoutLeverage;
      })

      let symbolDefaultLeverage

      if (currentLeverage.symbol_default_leverage.length > 0 && symbolMinLeverage.length == 0) {
        symbolDefaultLeverage = symbolLeverage[symbolLeverage.length - 1]
      } else {
        symbolDefaultLeverage = symbolMinLeverage[0];
      }

      let minimumLeverage = 1;
      if (currentLeverage) {
        minimumLeverage = getMinimumLeverage(
          currentLeverage.user_default_leverage,
          [],
          symbolDefaultLeverage.max_leverage,

        );
      }
      const lvg = minimumLeverage || 1;
      const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate *askPriceExchangeRate;
      const requiredMargin = orderQuantity * (converted_entry_price / lvg);
      return isNaN(requiredMargin)
        ? 0
        : requiredMargin < 1 ? requiredMargin?.toFixed(5)
          : Math.round(requiredMargin * 10) / 10
    } else if (currentLeverage && currentLeverage.user_default_leverage) {

      const lvg = currentLeverage.user_default_leverage || 1;
      console.log("minimumLeverage", lvg)
      const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate *askPriceExchangeRate;
      const requiredMargin = orderQuantity * (converted_entry_price / lvg);
      return isNaN(requiredMargin)
        ? 0
        : requiredMargin < 1 ? requiredMargin?.toFixed(5)
          : Math.round(requiredMargin * 10) / 10

    }
    // Fallback if no leverage data available
    return 0;
  };
  const calculateRequiredMarginAccToBidPrice = () => {
    let reqMarginWithoutLeverage = orderQuantity * orderEntryPrice * selectedSymbolExchangeRate * bidPriceExchangeRate;
    
    // Update current exposure level for leverage tier indicator (only when pending order tab is active)
    if (selectedOrderTab === 'pending-order') {
      setCurrentExposureLevel(reqMarginWithoutLeverage);
    }

    const currentLeverage = getCurrentSymbolLeverage();
    if (
      currentLeverage &&
      Array.isArray(currentLeverage.group_level_leverage) &&
      currentLeverage.group_level_leverage.length > 0
    ) {

      let symbolLeverage = currentLeverage.group_level_leverage.sort((a, b) => {
        const aLevel = a && a.exposure_level !== null && a.exposure_level !== undefined
          ? parseFloat(a.exposure_level)
          : Infinity;
        const bLevel = b && b.exposure_level !== null && b.exposure_level !== undefined
          ? parseFloat(b.exposure_level)
          : Infinity;
        return aLevel - bLevel;
      });

      let groupMinLeverage = symbolLeverage.filter(lev => {
        // Ensure `lev.exposure_level` exists and is a valid number before comparison
        const exposureLevel = lev && lev.exposure_level !== null && lev.exposure_level !== undefined
          ? parseFloat(lev.exposure_level)
          : NaN;
        return !isNaN(exposureLevel) && exposureLevel >= reqMarginWithoutLeverage;
      })




      let groupDefaultLeverage

      if (currentLeverage.group_level_leverage.length > 0 && groupMinLeverage.length == 0) {
        groupDefaultLeverage = symbolLeverage[symbolLeverage.length - 1]
      } else {
        groupDefaultLeverage = groupMinLeverage[0];
      }

      let minimumLeverage = 1;
      if (currentLeverage) {
        minimumLeverage = getMinimumLeverage(
          currentLeverage.user_default_leverage,
          groupDefaultLeverage.max_leverage,
          []
        );
      }
      const lvg = minimumLeverage || 1;
      const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate* bidPriceExchangeRate;
      const requiredMargin = orderQuantity * (converted_entry_price / lvg);
      return isNaN(requiredMargin)
        ? 0
        : requiredMargin < 1 ? requiredMargin?.toFixed(5)
          : Math.round(requiredMargin * 10) / 10
    } else if (
      currentLeverage &&
      Array.isArray(currentLeverage.symbol_default_leverage) &&
      currentLeverage.symbol_default_leverage.length > 0
    ) {
      let symbolLeverage = currentLeverage.symbol_default_leverage.sort((a, b) => {
        // Handle missing or invalid `exposure_level` values using parseFloat
        const aLevel = a && a.exposure_level !== null && a.exposure_level !== undefined
          ? parseFloat(a.exposure_level)
          : Infinity;
        const bLevel = b && b.exposure_level !== null && b.exposure_level !== undefined
          ? parseFloat(b.exposure_level)
          : Infinity;
        return aLevel - bLevel;
      })

      let symbolMinLeverage = symbolLeverage.filter(lev => {
        // Ensure `lev.exposure_level` exists and is a valid number before comparison
        const exposureLevel = lev && lev.exposure_level !== null && lev.exposure_level !== undefined
          ? parseFloat(lev.exposure_level)
          : NaN;
        return !isNaN(exposureLevel) && exposureLevel >= reqMarginWithoutLeverage;
      })

      let symbolDefaultLeverage

      if (currentLeverage.symbol_default_leverage.length > 0 && symbolMinLeverage.length == 0) {
        symbolDefaultLeverage = symbolLeverage[symbolLeverage.length - 1]
      } else {
        symbolDefaultLeverage = symbolMinLeverage[0];
      }

      let minimumLeverage = 1;
      if (currentLeverage) {
        minimumLeverage = getMinimumLeverage(
          currentLeverage.user_default_leverage,
          [],
          symbolDefaultLeverage.max_leverage,

        );
      }
      const lvg = minimumLeverage || 1;
      const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate* bidPriceExchangeRate;
      const requiredMargin = orderQuantity * (converted_entry_price / lvg);
      return isNaN(requiredMargin)
        ? 0
        : requiredMargin < 1 ? requiredMargin?.toFixed(5)
          : Math.round(requiredMargin * 10) / 10
    } else if (currentLeverage && currentLeverage.user_default_leverage) {

      const lvg = currentLeverage.user_default_leverage || 1;
      console.log("minimumLeverage", lvg)
      const converted_entry_price = orderEntryPrice * selectedSymbolExchangeRate* bidPriceExchangeRate;
      const requiredMargin = orderQuantity * (converted_entry_price / lvg);
      return isNaN(requiredMargin)
        ? 0
        : requiredMargin < 1 ? requiredMargin?.toFixed(5)
          : Math.round(requiredMargin * 10) / 10

    }
    // Fallback if no leverage data available
    return 0;
  };

  //#region API CALLS

  const openPendingOrder_api = async (margin, dir) => {
    try {
      const currentDate = new Date();
      const currentDateTime = new Date(currentDate);

      const data: Order = {
        id: -1,
        created_at: null,
        symbol: selectedAuthSymbol,
        quantity: orderQuantity,
        amount: amount,
        asset_type: assetState.type,
        // direction: direction,
        entry_price: orderEntryPrice,
   
        direction: dir,
        // entry_price: dir == "Buy" ? askPrice : bidPrice,
        // converted_entry_price: (dir == "Buy" ? askPrice : bidPrice) * selectedSymbolExchangeRate,
        TP: takeProfit,
        SL: stopLoss,
        netEUR: 0, // Set appropriate values
        status: "",
        quote_asset: symbolInfo.quote_asset,
        userId: user.userId,
        margin: margin,
        exit_price: 0,
        totalUnrealizedPnL: metrics.totalUnrealizedPnL,
        order_id: "OID" + Math.floor(100000 + Math.random() * 900000),
        status_updated_at: null,
        expires_at: expiresAt ? expiresAt : null,
        comment: orderComment,
        lot_step: selectedLotStep,
        trade_type: symbolInfo.trade_type,
        lot_size: lotSize
      };

      const response = await APIMiddleware.post(API_ENDPOINT_OPEN_ORDER(), data);

      const data_m = {
        ...response.data,
        created_at: new Date(response.data.created_at).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
      };

      // Show a success notification
      toast.success(t('toasts.orderOpened'), { position: "top-right" });
      document.getElementById("openSound").play();
      localStorage.accountManager = "open-orders-acc";
      setIsOrderOpening(false);
    } catch (error: any) {
      const errorMsg = error?.response?.data?.data?.error || error?.response?.data?.error || error?.response?.data?.message || 'Error opening order';
      toast.error(errorMsg, { position: "top-right" });
      // Handle API request error
      console.error(`API request error: ${API_ENDPOINT_OPEN_ORDER()}`, error);
    } finally {
      setIsOrderOpening(false);
    }
  };

  const handleLotStepOptionChange = (lotStep) => {
    setSelectedLotStep(parseFloat(lotStep.value));
    setSelectedLotStepOption(lotStep);
  }

  const handleInputChange = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');

    // Split the input into parts if multiple dots are present
    const floatValueParts = sanitizedValue.split('.');

    // Allow only one dot and concatenate valid parts
    const validValue = floatValueParts.length > 2
      ? `${floatValueParts[0]}.${floatValueParts[1]}`
      : sanitizedValue;

    // Update the state with the valid value
    setInputValue(validValue);
  };

  const handleQtyOptionChange = (option) => {
    setOrderQuantity(parseFloat(option.value));
    setSelectedQtyOption(option);
  }

  const handleQtyInputChange = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    const floatValueParts = sanitizedValue.split('.');
    // Allow only one dot and concatenate valid parts
    const validValue = floatValueParts.length > 2
      ? `${floatValueParts[0]}.${floatValueParts[1]}`
      : sanitizedValue;
    // Update the state with the valid value
    setInputQtyValue(validValue);
  };

  // Chart already shows the platform loader while symbols load.
  if (loadingSymbolContext) {
    return null;
  }

  return (
    <>
      <div className="spread-equity">
        {t('orderPanel.available')}: {metrics?.userCurrencySymbol ? `${metrics.userCurrencySymbol} ` : ''}
        {metrics?.userCurrencySymbol && metrics?.equity !== undefined
          ? metrics?.freeMargin?.toFixed(2)
          : '---'}{' '}
      </div>
      <div className="input-wrapper">
        <label htmlFor="order-input" className="order-label">
          {t('orderPanel.price')}:
        </label>
        <div className="crypto-input">
          <input
            type="text"
            inputMode="decimal"
            placeholder="0.00"
            id="order-entry-price"
            className="order-input"
            value={orderEntryPriceInput}
            onChange={(e) => {
              const val = e.target.value;
              if (val === '' || priceInputPattern.test(val)) {
                setOrderEntryPriceInput(val);
                setOrderEntryPrice(val === '' || val === '.' ? 0 : parseFloat(val) || 0);
              }
            }}
            onKeyDown={(e) => {
              if (['e', 'E', '+', '-'].includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </div>
      </div>

      <div className="input-wrapper">
        <label htmlFor="order-label">{t('orderPanel.size')}:</label>
        <div className="crypto-input">
          {
            assetState.type === "base_asset" ? (
              <input
                type="number"
                inputMode="decimal"
                placeholder="0.00"
                value={orderQuantity ?? ""}
                id="amount-input"
                maxLength={32}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) {
                    setOrderQuantity(parseFloat(val));
                  }
                }}
                onKeyDown={(e) => {
                  if (['e', 'E', '+', '-'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            ) : (
              <input
                type="number"
                inputMode="decimal"
                value={amount || ""}
                placeholder="0.00"
                id="amount-input"
                maxLength={32}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) {
                    setAmount(parseFloat(val));
                  }
                }}
                onKeyDown={(e) => {
                  if (['e', 'E', '+', '-'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            )
          }

          {/* <select onChange={(e) => handleAssetChange(e.target.value)}>
    {assetState.type === "base_asset" ? (
      <>
        <option value={symbolInfo.base_asset}>{symbolInfo.base_asset}</option>
        <option value={symbolInfo.quote_asset}>{symbolInfo.quote_asset}</option>
      </>
    ) : (
      <>
        <option value={symbolInfo.quote_asset}>{symbolInfo.quote_asset}</option>
        <option value={symbolInfo.base_asset}>{symbolInfo.base_asset}</option>
      </>
    )}
  </select> */}

          <div className="new-asset">
            <SystemSelect embedded aria-label="Size unit"
              value={{ value: assetState.name, label: assetState.name }}
              options={[symbolInfo.base_asset, symbolInfo.quote_asset].filter(Boolean).map(asset => ({ value: asset, label: asset }))}
              onChange={option => { if (option) { handleAssetChange(option.value); setAssetOptions('false'); setFocusOut(true); } }}
            />
          </div>
        </div>
      </div>
      {/* <div className="reuqired-margin">
        <div className="title">{t('marketOrder.requiredMargin')}</div>
        <div className="value">
          {calculateOrderRequiredMargin()}{" "}
          {user?.userCurrencyName ||"EUR"}
        </div>
      </div> */}
      {selectedOrderTab === 'pending-order' ? (
        <SLTP
          isPendingOrder={true}
          isEditPosition={false}
          handleDisabledButton={handleDisabledButton}
          handleSLPipsChange={handleSLPipsChange}
          handleTPPipsChange={handleTPPipsChange}
          handleProfitChange={handleProfitChange}
          handleLossChange={handleLossChange}
          direction={direction}
          quantity={orderQuantity}
          entryPrice={orderEntryPrice}
          secondPrice={orderEntryPrice}
          EntryPriceExchangeRate={ direction === "Buy" ? askPriceExchangeRate : bidPriceExchangeRate}
          handleSLTPDirection={handleSLTPDirectionChange}
        />
      ) : (
        <></>
      )}
      {/* <div className="text-bx">
        <div className="text-area-letter-counter-sltp">
          <span id="count-comment-letters-po">0</span>/100
        </div>
        <textarea
          className="comment-sltp-lst"
          placeholder={t('ea.comment')}
          onInput={(e) => {
            countLetters(e);
          }}
          value={orderComment}
          onChange={(e) => {
            setOrderComment(e.target.value);
          }}
        ></textarea>
      </div> */}

      <div className="buy-sell-place-button-wrapper">
        <div className="button-with-stats">
          <button
            disabled={
              isFirstLoginDisabled ||
              (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3) ||
              localStorage.getItem('accountType') == '0' ||
              platFromData[5]?.accessRight == 2 ||
              !bidPrice ||
              !askPrice ||
              isOrderOpening ||
              isButtonDisabled ||
              direction == 'Sell'
            }
            className={`place-order-button place-order-button-buy`}
            onClick={() => {
              placeOrder('Buy');
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
              backgroundColor: selectedStyle.buyColor,
            }}
          >
            <b style={{ fontSize: '14px', fontWeight: 'bolder' }}>
              {!isOrderOpening ? t('marketOrder.buyLong') : t('marketOrder.loading')}
            </b>
            <br />
            {/* <span>
                  {formatPriceUptoDecimals(askPrice, symbolInfo.digit)}
                </span> */}
            {/* <span style={{fontSize: '13px'}}>
                  {quantity.toFixed(2) || ""} {selectedAuthSymbol} @{" "}
                  {formatPrice(askPrice)}
                </span> */}
          </button>
          <div className="order-stats">
            <div>
              <span>{metrics?.userCurrencySymbol || ''}</span>
              <b>{calculateRequiredMarginAccToAskPrice() || '---'}</b>{' '}
            </div>
          </div>
        </div>
        <div className="button-with-stats">
          <button
            disabled={
              isFirstLoginDisabled ||
              (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3) ||
              localStorage.getItem('accountType') == '0' ||
              platFromData[5]?.accessRight == 2 ||
              !bidPrice ||
              !askPrice ||
              isButtonDisabled ||
              direction == 'Buy'
            }
            className={`place-order-button place-order-button-sell`}
            onClick={() => {
              placeOrder('Sell');
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
              backgroundColor: selectedStyle.sellColor,
            }}
          >
            <b style={{ fontSize: '14px', fontWeight: 'bolder' }}>
              {!isOrderOpening ? t('marketOrder.sellShort') : t('marketOrder.loading')}
            </b>
            <br />
            {/* <span>
                  {formatPriceUptoDecimals(bidPrice, symbolInfo.digit)}
                </span> */}
            {/* <span style={{fontSize: '13px'}}>
                  {quantity.toFixed(2) || ""} {selectedAuthSymbol} @{" "}
                  {formatPrice(bidPrice)}
                </span> */}
          </button>
          <div className="order-stats">
            <div>
              <span>{metrics?.userCurrencySymbol || ''}</span>
              <b>{calculateRequiredMarginAccToBidPrice() || '---'}</b>{' '}
            </div>
          </div>
        </div>
      </div>

      { isTradingDisabled(platFromData[5]) ? (
          <button className="mkt-closed-notification-btn" onClick={() => {}}>
            {localizeTradingBannerMessage(getTradingDisabledBannerMessage(platFromData[5]), t)}
          </button>
      ) : platFromData[5]?.accessRight == 2 ? (
          <button className="mkt-closed-notification-btn" onClick={() => {}}>
            {t('tradingLock.closeOnly')}
          </button>
      ) : null}

    </>
  );
};

export default PendingOrder;
